<template>
  <div v-if="modalIsShown" class="channel-advisor-module">
    <the-modal :custom-class="`-chAdvModal ${titleText ? '--custom-title' : ''}`"  
    modalid="channeladvisor"
    >
      <iframe
        v-if="modalIsShown"
        :src="iframeUrl"
        :title="titleText"
        ref="iframeCV"
      ></iframe>
      <template v-slot:title>
        <component v-if="titleText" :is="headingLevel" class="modal-title">{{
          titleText
        }}</component>
      </template>
    </the-modal>
  </div>
</template>

<script>
// tagging plan yet to be defined
import { AnalyticsHandler } from '../../scripts/directives/analyticsHandler/AnalyticsHandler';
import { eventBus } from 'EventBus/';

export default {
  name: 'ChannelAdvisor',
  props: {
    titleText: {
      type: String,
      default: 'Buy Online Options',
      required: false,
    },
    headingLevel: {
      type: String,
      default: 'h2',
      required: false,
    },
  },
  data() {
    return {
      modalIsShown: false,
      iframeUrl: '',
      additionalInfo: {
        productId: undefined,
        productName: undefined,
      },
      analyticsData: {},
    };
  },
  beforeDestroy() {
    eventBus.$off('overlayHandler', this.close);
    eventBus.$off('modalCloseEvent', this.close);
  },
  mounted() {
    eventBus.$on('modalCloseEvent', this.close);
    eventBus.$on('overlayHandler', this.close);
    eventBus.$on('open-channel-advisor-modal', this.open);
    window.addEventListener('message', this.handleIframeMessage, false);
  },
  methods: {
    fireEventTag(eventName) {
      try {
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'userActionEvent',
          event_name: eventName,
          ecommerce: 'undefined',
          product_info: `${this.additionalInfo.productName}::${this.additionalInfo.productId}`,
        });
      } catch (error) {
        console.error(error);
      }
    },
    close() {
      this.modalIsShown = false;

      this.fireEventTag('close_eretail_popup');
    },
    open(payload) {
      const iframeUrl = payload.url;

      this.additionalInfo = {
        productId: payload.productId,
        productName: payload.productName,
      };

      this.analyticsData = payload.analyticsData;

      this.iframeUrl = iframeUrl || '';
      this.modalIsShown = true;

      this.fireEventTag('buy_now');

      setTimeout(() => {
        let iframeDiv = this.$refs.iframeCV;
        if (iframeDiv) {
          iframeDiv.focus();
        }
      }, 500);
    },
    handleIframeMessage(message) {
      if (
        message &&
        message.data &&
        typeof message.data === 'string' &&
        message.data.startsWith('uaevent')
      ) {
        let eventArray = message.data.split('|');

        // eventArray from CA - getting values for analytics
        let storeNameString = eventArray.length ? eventArray[3] : '';
        let priceString = eventArray.length ? eventArray[4] : '';
        let ecommerceString = eventArray.length ? eventArray[2] : '';

        let storeName = storeNameString.split('::').pop();
        let productPrice = priceString.split('-').pop();

        this.analyticsData.category =
          this.capitalizeFirstLetter(ecommerceString);
        this.analyticsData.store_name = storeName;
        if (this.analyticsData?.ecommerce?.add?.products) {
          this.analyticsData.ecommerce.add.products[0].price = productPrice;
        }

        try {
          AnalyticsHandler.getAnalyticsHandler().push({
            ...this.analyticsData,
            type: 'userActionEvent',
          });
        } catch (error) {
          console.error(error);
        }
      }
      if (
        message &&
        message.data &&
        typeof message.data === 'string' &&
        message.data.startsWith('closeevent')
      ) {
        this.close();
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style lang="scss" src="./channel-advisor.scss"></style>
